import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ApiClient from '../services/api-client';

export function useSaleViewData(companyId) {
    const { t } = useTranslation();
    const [saleViewData, setSaleViewData] = useState(null);
    const [saleViewLoading, setSaleViewLoading] = useState(true);

    useEffect(() => {
        if (!companyId) return;
        let cancelled = false;
        ApiClient.getSalesView(companyId)
            .then(response => {
                if (!cancelled) setSaleViewData(parseSaleViewData(response.data, t));
            })
            .catch(error => {
                console.error(error?.response?.data?.message || error.message || error.toString());
            })
            .finally(() => {
                if (!cancelled) setSaleViewLoading(false);
            });
        return () => { cancelled = true; };
    }, [companyId]);

    return { saleViewData, saleViewLoading };
}

function parseSaleViewData(data, t) {
    const {
        companyBranches = [],
        companyInvoiceTypes = [],
        paymentTypes = [],
        vats = [],
        measurementUnits = [],
        vatCategoryExceptions = [],
        myDataMovePurposes = [],
        applicationSosMessages,
        countSales,
        myDataMoreTaxes = [],
        myDataMoreTaxesTypes = [],
    } = data;

    const optionBranches = companyBranches.map(e => ({ value: e.id, label: e.name, model: e }));

    const optionsinvoiceTypes = companyInvoiceTypes.map(e => ({
        value: e.id,
        label: e.name,
        myDataInvoiceType: e.myDataInvoiceType,
        invoiceTypeClassifications: e.invoiceTypeClassifications,
    }));

    const optionspaymentTypes = paymentTypes.map(e => ({ value: e, label: e }));
    const optionsVats = vats.map(e => ({ value: e.id, label: t(e.id), model: e }));
    const optionsMU = measurementUnits.map(e => ({ value: e, label: t(e) }));
    const optionsVCT = vatCategoryExceptions.map(e => ({ value: e, label: t(e) }));
    const optionsMP = myDataMovePurposes.map(e => ({ value: e, label: t(e) }));

    
    const myDataMoreTaxesOptions = myDataMoreTaxes.map(e => ({
        value: e.type === 'DEDUCTION' ? e.id : e.uid,
        uid: e.type === 'DEDUCTION' ? e.id : e.uid,
        label: e.type === 'DEDUCTION' ? e.name : t('TAX_' + e.uid),
        type: e.type,
        key: e.key,
        amountValue: e.amountValue,
        subtracted: e.subtracted,
    }));

    const moreTaxesTypesOptions = myDataMoreTaxesTypes.map(e => ({ value: e, label: t(e) }));

    const groupTaxes = myDataMoreTaxesOptions.reduce((acc, a) => {
        acc[a.type] = [...(acc[a.type] || []), a];
        return acc;
    }, {});

    let sosMessage = null;
    if (applicationSosMessages?.sosMessage) {
        sosMessage = {
            message: applicationSosMessages.sosMessage,
            alertClass: `alert alert-${applicationSosMessages.sosMessageStatus} alert-dismissible fade show`,
        };
    }

    return {
        content: {
            sale: null,
            paymentTypes: optionspaymentTypes,
            vats: optionsVats,
            measurementUnits: optionsMU,
            withHoldTaxes: [],
            otherTaxes: [],
            vatCategoryExceptions: optionsVCT,
            movePurposes: optionsMP,
            optionsinvoiceTypes,
            optionBranches
        },
        moreTaxesOptions: myDataMoreTaxesOptions,
        moreTaxesTypesOptions,
        otherTaxesOptions: groupTaxes['OTHER_TAXES'] || [],
        myDataMoreTaxesOptions,
        salesLeft: countSales,
        sosMessage,
    };
}
